import dynamic from "next/dynamic";
import useIsMetamaskEnabled from "../../hooks/useIsMetamaskEnabled";

const MetamaskAuthBtn = dynamic(() => import("./MetamaskAuthButton"), {
  ssr: false,
});

const MetamaskAuthButton: FC<MetamaskAuthButtonProps> = (props) => {
  const isMetamaskEnabled = useIsMetamaskEnabled();

  if (!isMetamaskEnabled) {
    return null;
  }
  return <MetamaskAuthBtn {...props} />;
};

export default MetamaskAuthButton;
